export default __webpack_public_path__ + "static/media/food1_thumb.e1fc40be.jpg";